<app-nav-red-logo></app-nav-red-logo>
<main class="main-wrapper ">
 <section class="container ">
  <h2 class="text-center ">Get in Touch</h2>
  <div class="mb-5 text-center ">
    <p class="mb-5">Have a Question? <br>
    We'd love to hear from you.
    </p>

    <p class="mb-5">
      <a href="tel:+2347046626460">+2347046626460</a><br>
      <a href="mailto:enquiry@zumeraproperty.com ">enquiry&#64;zumeraproperty.com</a><br>
      <a href="mailto:Invest@zumeraproperty.com ">Invest&#64;zumeraproperty.com</a>
    </p>

    <p class="mb-5">Kilometer 10, Benin Sapele Road, <br>
       Bypass Benin City, Edo State, Nigeria.
    </p>


  </div>
 </section>

<section class="faq">
  <h2 class="text-center ">FAQ</h2>

  <div class="container">
    <div class="accordion" id="accordionExample">
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button " type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
            How can I be part of the on-going project?
          </button>
        </h2>
        <div id="collapseSeven" class="accordion-collapse collapse show" data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <p>By becoming either debt or equity investor. Zumera property projects promise long term high return on investments (ROI) to stakeholders. Kindly contact our professional team for further information.
            </p>
          </div>
        </div>
      </div>
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
            Where is the ZUMERA TOWER located?
          </button>
        </h2>
        <div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
          <div class="accordion-body">
           <p>The tower is located at km 10 Sapele Road bypass, Benin City. It provides easy access to major transportation routes and amenities.         </p>
          </div>
        </div>
      </div>
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
            What sustainable features does the tower offer?
          </button>
        </h2>
        <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <p>Our tower incorporates energy-efficient systems, waste reduction strategies, green spaces, and environmentally conscious building materials.
            </p>
          </div>
        </div>
      </div>
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
            What are the key features of the tower?
          </button>
        </h2>
        <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <p>Our commercial tower offers state-of-the-art infrastructure, modern design, sustainable energy solutions, ample parking, and customizable floor plans.
            </p>
          </div>
        </div>
      </div>
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseThree">
            How can I schedule a tour of the tower?
          </button>
        </h2>
        <div id="collapseFour" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <p>To schedule a tour, reach out to our marketing department at 07046626460 to arrange a visit and learn more about the tower’s offerings.
            </p>
          </div>
        </div>
      </div>
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
            What types of businesses are suitable for the tower?
          </button>
        </h2>
        <div id="collapseSix" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <p>Our tower is designed to accommodate a wide range of businesses, including corporate offices, retail outlets, restaurants, and more.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
 
</main>

<app-footer class="w-100 d-none d-sm-block"></app-footer>
<app-footer-sm  class="w-100 d-sm-none"></app-footer-sm>